import DashboardLayout from "../layouts/Dashboard/DashboardLayout.jsx";

var indexRoutes = [
  { path: "/", name: "DashboardLayout", component: DashboardLayout },
];

export default indexRoutes;
